<script lang='ts'>
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    // no-op
  },
})
</script>

<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style lang='scss'>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
</style>
